import { LayoutNav } from "@/Nav";
import {
  createFileRoute,
  Outlet,
  useRouter,
  useLocation,
} from "@tanstack/react-router";
import { useEffect } from "react";
import { useBusinessAuthUserInfo } from "~/services/business/auth";
import { useNavVisibilityStore } from "&/navVisibility";
import { TermsConsentGate } from "@/common/TermsConsentGate";

export const Route = createFileRoute("/business/layout")({
  component: Home,
});

function Home() {
  const { history } = useRouter();
  const location = useLocation();
  const { data: businessUserInfo } = useBusinessAuthUserInfo();
  const navVisible = useNavVisibilityStore((s) => s.visible);

  // 선생님 할당 상태에 따른 리다이렉트 로직
  useEffect(() => {
    if (businessUserInfo && businessUserInfo.isTeacher) {
      const currentPath = location.pathname;

      // teacher 페이지가 아닌 다른 페이지에 있을 때 할당된 업체가 없으면 teacher 페이지로 이동
      if (
        !businessUserInfo.assignedCompany &&
        currentPath !== "/business/layout/teacher"
      ) {
        history.push("/business/layout/teacher");
      }

      // teacher 페이지에 있는데 할당된 업체가 있으면 메인 페이지로 이동
      if (
        businessUserInfo.assignedCompany &&
        currentPath === "/business/layout/teacher"
      ) {
        history.push("/business/layout/home");
      }
    }
  }, [businessUserInfo, location.pathname, history]);

  return (
    <>
      {/* 보호자 레이아웃과 동일: 래퍼가 콘텐츠만큼 자라서 main 이 스크롤한다.
          (min-h-0 로 높이를 잠그면 래퍼가 내부 스크롤러가 되어 nav 아래 빈 띠가 생김.
          overflow-x-hidden 은 computed overflow-y 를 auto 로 바꾸므로 여기 두면 안 됨 — 필요한 화면에서 개별 처리) */}
      <div
        className={`flex flex-col flex-1 min-w-0 bg-[#F5F5F5] ${navVisible ? "pb-24" : ""}`}
      >
        <Outlet />
      </div>
      <LayoutNav type="business" />
      {/* 약관 개정 시 재동의 모달 — 로그인 상태에서만 동작 */}
      <TermsConsentGate />
    </>
  );
}
